import { createContentCollection } from './content'

// Manual ordering of tools
const toolsOrder = [
  'sandbox-new',
  'bookmarks',
  'discordplexstatus',
  'jottt',
]

const modules = import.meta.glob('/src/content/tools/*.mdx', { eager: true, import: 'frontmatter' })
const { items: tools, getBySlug: getToolBySlug } = createContentCollection(
  modules,
  '/src/content/tools/',
  toolsOrder
)

export { tools, getToolBySlug }
